(() => {
  'use strict';

  const root = document.querySelector('[data-dg-lab-tool="cps"]');
  if (!root) return;

  if (root.dataset.dgLabCpsInitialized === 'true') return;
  root.dataset.dgLabCpsInitialized = 'true';

  const area = root.querySelector('#area');
  const duration = root.querySelector('#duration');

  if (!area || !duration) return;

  let count = 0;
  let mode = 'idle'; // idle | running | finished
  let endTime = 0;
  let timer = 0;
  let best = 0;

  function get(id) {
    return root.querySelector('#' + id);
  }

  function stopTimer() {
    if (timer) {
      clearInterval(timer);
      timer = 0;
    }
  }

  function formatNumber(value, decimals = 2) {
    return value.toLocaleString('es-ES', {
      maximumFractionDigits: decimals
    });
  }

  function setIdleState() {
    stopTimer();

    count = 0;
    mode = 'idle';
    endTime = 0;

    get('cps').textContent = '0,00';
    get('clicks').textContent = '0';
    get('left').textContent = formatNumber(+duration.value, 1);

    area.innerHTML = `
      <div>
        <span class="sphere big-sphere"></span>
        <div class="status">Pulsa para comenzar</div>
      </div>
    `;
  }

  function startTest() {
    count = 0;
    mode = 'running';

    const seconds = +duration.value;

    endTime = performance.now() + seconds * 1000;

    get('cps').textContent = '0,00';
    get('clicks').textContent = '0';
    get('left').textContent = formatNumber(seconds, 1);

    area.innerHTML = `
      <div class="status" aria-live="polite">
        En curso
      </div>
    `;

    stopTimer();
    timer = setInterval(tick, 50);
  }

  function finish() {
    if (mode !== 'running') return;

    mode = 'finished';
    stopTimer();

    const seconds = +duration.value;
    const cps = count / seconds;

    best = Math.max(best, cps);

    get('cps').textContent = formatNumber(cps);
    get('best').textContent = formatNumber(best);
    get('left').textContent = '0,0';
    get('clicks').textContent = count;

    area.innerHTML = `
      <div class="status" aria-live="polite">
        <strong>Prueba finalizada</strong><br>
        ${formatNumber(cps)} CPS · ${count} clics
        <br><br>
        <button type="button" class="btn primary" id="dg-lab-cps-reset">
          Repetir prueba
        </button>
      </div>
    `;

    const resetButton = area.querySelector('#dg-lab-cps-reset');

    if (resetButton) {
      resetButton.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();
          setIdleState();
        },
        { once: true }
      );
    }
  }

  function tick() {
    if (mode !== 'running') return;

    const left = Math.max(0, endTime - performance.now());

    get('left').textContent = formatNumber(left / 1000, 1);

    if (left <= 0) {
      finish();
    }
  }

  area.addEventListener('click', (event) => {
    if (event.detail === 0) return;

    if (mode === 'finished') {
      return;
    }

    if (mode === 'idle') {
      startTest();
    }

    if (mode !== 'running') return;

    count++;

    get('clicks').textContent = count;

    const elapsedSeconds =
      (+duration.value * 1000 - (endTime - performance.now())) / 1000;

    const safeElapsed = Math.max(0.1, elapsedSeconds);
    const currentCps = count / safeElapsed;

    get('cps').textContent = formatNumber(currentCps);
  });

  duration.addEventListener('change', () => {
    if (mode === 'running') return;

    setIdleState();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && mode === 'running') {
      finish();
    }
  });

  window.addEventListener(
    'pagehide',
    stopTimer,
    { once: true }
  );

  setIdleState();
})();